import SecuritySettings from "@/components/shared/settings/sections/SecuritySettings";
import { HOME_ORG_PATH } from "@/config/constants";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";

const FrontEndSecuritySettings = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Security Settings");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Home", path: HOME_ORG_PATH },
            { label: "Settings" },
            { label: "Security" },
        ]);
    });

    return <SecuritySettings />;
};

export default FrontEndSecuritySettings;
